import React, {useContext} from 'react';
import { FormContext } from './FormEngine';
import {PDFViewer} from '@react-pdf/renderer';
import PdfForm from './pdf/PdfForm';

const FormReview = props => {
    const ctx = useContext(FormContext);

    return <PDFViewer height="740px" width="99%">
        <PdfForm form={ctx}/>
    </PDFViewer>
}

export default FormReview;